import {
  Calendar,
  ChartColumn,
  ClipboardMinus,
  Clock4,
  DollarSign,
  Gift,
  Star,
  TrendingUp,
  User2,
  UserPlus,
} from "lucide-react";
import React from "react";

export default function Overview() {
  return (
    <div className="px-4 py-8 bg-[#0B0D0F] max-sm:h-[100vh] h-[100vh] overflow-auto space-y-4">
      <div className="flex flex-wrap gap-4 w-full ">
        {/* Column 1 */}
        <div className="flex flex-col gap-4 flex-1 min-w-[250px]">
          {/* Club Leader Card */}
          <div
            className="relative w-full h-auto 
            bg-[linear-gradient(135deg,_#181C25_0%,_#272B35_100%)]
            border border-[rgba(255,210,77,0.2)]
            shadow-[0px_1px_2px_rgba(0,0,0,0.05)]
            rounded-[10px]
            px-6 py-5 box-border"
          >
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-[#FFD24D] flex justify-center items-center text-xl text-[#0F121A] font-bold">
                T
              </div>
              <div>
                <h1 className="text-[#FFECB3] font-bold text-xl leading-6">
                  Club Leader Test
                </h1>
                <p className="text-[#ADA385] text-[14px] leading-5">
                  Reg. ID: CL123456
                </p>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-2 text-[#FFD24D] text-[12.4px]">
              <svg
                width="20"
                height="20"
                viewBox="0 0 17 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="shrink-0"
              >
                <path
                  d="M5.60353 10.705C7.92378 10.705 9.80471 8.82405 9.80471 6.5038C9.80471 4.18355 7.92378 2.30261 5.60353 2.30261C3.28328 2.30261 1.40234 4.18355 1.40234 6.5038C1.40234 8.82405 3.28328 10.705 5.60353 10.705Z"
                  stroke="#FFD24D"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.6707 8.16455C13.3326 8.41132 13.9216 8.82101 14.3832 9.35573C14.8448 9.89044 15.1641 10.5329 15.3116 11.2238C15.4591 11.9146 15.4301 12.6315 15.2271 13.3081C15.0242 13.9847 14.6539 14.5992 14.1505 15.0948C13.6471 15.5904 13.0269 15.9511 12.3472 16.1435C11.6675 16.3358 10.9502 16.3537 10.2618 16.1954C9.57332 16.0372 8.9359 15.7078 8.40845 15.2379C7.881 14.768 7.48055 14.1727 7.24414 13.5071"
                  stroke="#FFD24D"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.9082 5.10559H5.6084V7.90638"
                  stroke="#FFD24D"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11.7032 10.6262L12.1933 11.1234L10.2188 13.0979"
                  stroke="#FFD24D"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="text-sm">256 Affiliate Coins</span>
            </div>
          </div>

          {/* Quote Card */}
          <div
            className="w-full 
            bg-[linear-gradient(135deg,_rgba(255,210,77,0.1)_0%,_rgba(255,210,77,0.05)_100%),_#181C25]
            border border-[rgba(255,210,77,0.3)]
            shadow-[0px_1px_2px_rgba(0,0,0,0.05)]
            rounded-[10px]
            flex justify-center items-center
            text-[#FFD24D] text-[14.5px] font-inter font-normal
            py-4 px-6 text-center"
          >
            “Hey Test, Earning ho Raha hain na?”
          </div>

          {/* Team Overview */}
          <div
            className="relative w-full h-auto 
            bg-[#181C25] 
            border border-[#363C49]
            shadow-[0_1px_2px_rgba(0,0,0,0.05)] 
            rounded-[10px]
            p-5 flex flex-col"
          >
            <h3 className="text-[#FFECB3] font-semibold text-xl leading-6  text-start mb-6">
              Team Overview
            </h3>
            <div className="flex flex-col sm:flex-row justify-between items-center gap-6 w-full">
              <div className="flex flex-col items-center">
                <span className="text-[#FFD24D] font-bold text-2xl leading-[30px]">
                  24
                </span>
                <span className="text-[#ADA385] text-[14px] leading-[17px] mt-[4px]">
                  Active Members
                </span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-[#33CC33] font-bold text-2xl leading-[30px]">
                  8
                </span>
                <span className="text-[#ADA385] text-[14px] leading-[17px] mt-[4px]">
                  This Month
                </span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-[#FFDF80] font-bold text-2xl leading-[30px]">
                  3
                </span>
                <span className="text-[#ADA385] text-[14px] leading-[17px] mt-[4px]">
                  Levels Deep
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4 flex-1 min-w-[250px]">
          {/* Today’s Earning Card */}
          <div className="relative w-full h-auto bg-[#181C25] border border-[#363C49] shadow-[0_1px_2px_rgba(0,0,0,0.05)] rounded-[10px] p-5 flex flex-col justify-between space-y-3">
            <div className="flex justify-between">
              <div className="bg-[rgba(255,210,77,0.2)] w-12 h-12 rounded-xl flex justify-center items-center">
                <DollarSign className="text-[#FFD24D] w-6 h-6" />
              </div>
              <div className="bg-[rgba(39,43,53,0.5)] w-12 h-12 flex rounded-xl justify-center items-center">
                <Clock4 className="w-6 h-6 text-[#ADA385]" />
              </div>
            </div>
            <h3 className="text-[#ADA385] font-normal text-[14px] leading-[24px]">
              Today’s Earning
            </h3>
            <div className="flex items-center gap-2">
              <span className="text-[#FFECB3] font-bold text-3xl leading-[30px]">
                ₹2,450
              </span>
              <TrendingUp className="text-[#33CC33] w-4 h-4" />
              <span className="text-[#33CC33] text-[14px]">+15.2%</span>
            </div>
          </div>

          {/* Direct Earning Card */}
          <div className="relative w-full h-auto bg-[#181C25] border border-[#363C49] shadow-[0_1px_2px_rgba(0,0,0,0.05)] rounded-[10px] p-5 flex flex-col justify-between space-y-3">
            <div className="flex justify-between">
              <div className="bg-[#33CC33]/20 w-12 h-12 rounded-xl flex justify-center items-center">
                <User2 className="text-[#33CC33] w-6 h-6" />
              </div>
              <div className="bg-[rgba(39,43,53,0.5)] w-12 h-12 flex rounded-xl justify-center items-center">
                <DollarSign className="w-6 h-6 text-[#ADA385]" />
              </div>
            </div>
            <h3 className="text-[#ADA385] font-normal text-[14px] leading-[24px]">
              Direct Earning
            </h3>
            <div className="flex items-center gap-2">
              <span className="text-[#33CC33] font-bold text-3xl leading-[30px]">
                ₹12,300
              </span>
              <TrendingUp className="text-[#33CC33] w-4 h-4" />
              <span className="text-[#33CC33] text-[14px]">+15.2%</span>
            </div>
          </div>

          {/* Invite Members Button */}
          <div className="px-4 py-4 bg-[linear-gradient(91.94deg,_#B17E32_-8.77%,_#F3E681_58.63%,_#CF9F41_107.45%)] flex justify-center items-center gap-2 rounded-lg w-full ">
            <UserPlus className="w-6 h-6" />
            Invite Members
          </div>
        </div>

        {/* Column 3 */}
        <div className="flex flex-col gap-4 flex-1 min-w-[250px]">
          {/* Last 2 Weeks */}
          <div className="relative w-full h-auto bg-[#181C25] border border-[#363C49] shadow-[0_1px_2px_rgba(0,0,0,0.05)] rounded-[10px] p-5 flex flex-col justify-between space-y-3">
            <div className="flex justify-between">
              <div className="bg-[rgba(255,210,77,0.2)] w-12 h-12 rounded-xl flex justify-center items-center">
                <ChartColumn className="text-[#FFD24D] w-6 h-6" />
              </div>
              <div className="bg-[rgba(39,43,53,0.5)] w-12 h-12 flex rounded-xl justify-center items-center">
                <Calendar className="w-6 h-6 text-[#ADA385]" />
              </div>
            </div>
            <h3 className="text-[#ADA385] font-normal text-[14px] leading-[24px]">
              Last 2 Weeks
            </h3>
            <div className="flex items-center gap-2">
              <span className="text-[#FFECB3] font-bold text-3xl leading-[30px]">
                ₹18,750
              </span>
              <TrendingUp className="text-[#33CC33] w-4 h-4" />
              <span className="text-[#33CC33] text-[14px]">+15.2%</span>
            </div>
          </div>

          {/* Club Member Bonus */}
          <div className="relative w-full h-auto bg-[#181C25] border border-[#363C49] shadow-[0_1px_2px_rgba(0,0,0,0.05)] rounded-[10px] p-5 flex flex-col justify-between space-y-3">
            <div className="flex justify-between">
              <div className="bg-[rgba(255,210,77,0.2)] w-12 h-12 rounded-xl flex justify-center items-center">
                <Gift className="text-[#FFD24D] w-6 h-6" />
              </div>
              <div className="bg-[rgba(39,43,53,0.5)] w-12 h-12 flex rounded-xl justify-center items-center">
                <Star className="w-6 h-6 text-[#ADA385]" />
              </div>
            </div>
            <h3 className="text-[#ADA385] font-normal text-[14px] leading-[24px]">
              Club Member Bonus
            </h3>
            <div className="flex items-center gap-2">
              <span className="text-[#FFD24D] font-bold text-3xl leading-[30px]">
                ₹5,750
              </span>
              <TrendingUp className="text-[#33CC33] w-4 h-4" />
              <span className="text-[#33CC33] text-[14px]">+15.2%</span>
            </div>
          </div>

          {/* View Reports */}
          <div className="h-96">
            <div className="bg-[#0F121A] text-[#FFECB3] border border-[rgba(255,210,77,0.3)] rounded-lg flex items-center justify-center gap-2 px-4 py-4 w-full">
              <ClipboardMinus className="w-6 h-6" />
              View Reports
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
